import { Component, OnDestroy, OnInit, Inject, Input } from '@angular/core';
import { SortOptions } from './table-sort-link-options';


export class TableSortLink {

     public sortOptions : SortOptions;
     public field : any;
     public label : any;

    onClickLink() {
      if (this.sortOptions.field == this.field) {
        this.sortOptions.reverse = !this.sortOptions.reverse;
      } else {
        this.sortOptions.field = this.field;
        this.sortOptions.reverse = false;
      }
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: '[table-sort-link]',
  template:  `
    <a (click)="onClickLink()">
      {{ label }}
      <i class="fa" [class.fa-sort-asc]="sortOptions.field == field && !sortOptions.reverse" [class.fa-sort-desc]="sortOptions.field == field && sortOptions.reverse"></i>
    </a>
  `
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'sortOptions': [{ type: Input },],
'field': [{ type: Input, args: ["table-sort-link", ] },],
'label': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
